import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Vecchie URL a root (pre-split) → equivalenti sotto /app. */
export function LegacyAppRedirect(): ReactElement {
  const location = useLocation();
  return <Navigate to={`/app${location.pathname}${location.search}`} replace />;
}
